<i18n src="@/lang/actions"></i18n>
<i18n src="@/lang/confirmations"></i18n>

<template>
  <el-main>
    <scripts-list
      :allowed-scripts="allowedScripts"
      :skip-code-list="skipCodeList"
      :custom-fields="customFields"
      v-if="allowedScripts"
      @save-script="handleSaveSharedScripts"
    />
  </el-main>
</template>

<script>
import ScriptsList from "../scripts/scripts-list";
import { mapActions, mapGetters, mapState } from "vuex";
import SharedCustomersServices from "../../store/classes/SharedCustomersServices";

export default {
  name: "ServicesInstallFeedbackScript",
  components: { ScriptsList },
  data: () => ({}),
  created() {
    this.getAllowedScripts();
  },
  methods: {
    ...mapActions({
      getAllowedScripts: "cache/allowed_scripts/getAllowedScripts"
    }),
    async handleSaveSharedScripts(script) {
      let service;
      let uuid = script.uuid;
      await script.save();
      if (
        !uuid ||
        (service = this.services.find(v => v.sharedScripts_uuid === uuid))
      ) {
        service = new SharedCustomersServices({
          type: "script",
          installed: true,
          sharedAmocrm_uuid: this.amo.uuid,
          sharedApikeys_uuid: null,
          sharedCustomers_uuid: this.customer.uuid,
          sharedPeriods_uuid: null,
          sharedWidgets_uuid: null,
          sharedScripts_uuid: script.uuid
        });
        await service._handleSave();
      }
      await this.$api.query({
        query: require("../../graphql/services/services_list.graphql"),
        variables: {
          customer: undefined,
          amo: this.$route.params.amo_id
        }
      });

      await this.$router.replace({
        name: "customers.details.installed_services.details",
        params: Object.assign({}, this.$route.params, {
          service_id: service.uuid
        })
      });
      this.$log("TYT", script, service);
    }
  },
  computed: {
    ...mapGetters({
      allowedScripts: "cache/allowed_scripts/allowedScripts",
      _amoAccount: "cache/amo_accounts/account"
    }),
    ...mapState({
      registeredScripts: state => state.cache.allowed_scripts.registeredScripts
    }),
    skipCodeList() {
      return this.services.map(v => v.code);
    },
    amoAccount() {
      return this._amoAccount(this.amo);
    },
    customFields() {
      try {
        return this.amoAccount.customFields(v => v.field_type === 1, [
          "lead",
          "contact"
        ]);
      } catch (e) {}
      return {};
    },
    amo() {
      return this.$attrs.amo;
    },
    customer() {
      return this.$attrs.customer;
    },
    services() {
      return this.$attrs.services.filter(v => v.type === "script");
    }
  }
};
</script>

<style scoped></style>
